import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ControlLayout, FilterItem, FilterType, InputType, PagingOptions, TextBoxOptions, DropdownOptions, ToggleSlideOptions } from 'bnsights-control-library';
import { UsersIDRequestModel } from '../../shared/models/UserModels/UsersIDRequestModel';
import { ConfigurationsService } from '../../shared/Services/ConfigurationsService.service';
import { ConfigurationModel } from '../../shared/models/ConfigurationModels/ConfigurationModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-configuration',
  templateUrl: './configuration.component.html'
})
export class ConfigurationComponent implements OnInit {
  ApiUrl = "/api/admin/Configuration/"
  searchTextBox: TextBoxOptions;
  ConfigurationForm = new FormGroup({});
  showFilter: boolean = false;
  ConfigurationPagingResult: any[] = [];
  ConfigurationPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  ScopesList: any[] = [];
  PermissionList: any[] = [];
  UsersList: any[] = [];
  LookupsList: any[] = [];
  LookupItemsList: any[] = [];
  ValueTypeList: any[] = [];
  ValueSourceList: any[] = [];

  ShowPermissionList: boolean = false;
  ShowUsersList: boolean = false;
  ShowLookupList: boolean = false;


  ShowValueAndDefaultValue: boolean = false;
  ShowValueToggleAndDefaultValue: boolean = false;
  ShowSourcePath: boolean = false;
  ShowSourceFunctionPath: boolean = false;
  ShowDropDownSource: boolean = false;
  ShowLookupItemsList: boolean = false;
  ShowSourceFunctionData: boolean = false;




  @ViewChild('ConfigurationPagingViewElement', { static: false }) input: ElementRef;


  //Add Model Controls
  AddConfigurationForm = new FormGroup({});
  Key: TextBoxOptions;
  Value: TextBoxOptions;
  DefaultValue: TextBoxOptions;
  SourcePath: TextBoxOptions;
  FunctionSourcePath: TextBoxOptions;
  SourceFuncValue: DropdownOptions = new DropdownOptions();
  SourceFuncDefaultValue: DropdownOptions = new DropdownOptions();
  ValueToggel: ToggleSlideOptions;
  DefaultValueToggel: ToggleSlideOptions;
  Scope: DropdownOptions;
  Type: DropdownOptions;
  PermissionSet: DropdownOptions;
  User: DropdownOptions;
  Source: DropdownOptions;
  Lookup: DropdownOptions;
  LookupValue: DropdownOptions;
  LookupDefaultValue: DropdownOptions;

  @ViewChild('CloseConfigurationModal', { static: false }) CloseConfigurationModal: ElementRef;

  //Edit Model Controls
  EditConfigurationForm = new FormGroup({});
  EditKey: TextBoxOptions = new TextBoxOptions();
  EditTextValue: TextBoxOptions = new TextBoxOptions();
  EditTextDefaultValue: TextBoxOptions = new TextBoxOptions();
  EditSourcePath: TextBoxOptions = new TextBoxOptions();
  EditFunctionSourcePath: TextBoxOptions = new TextBoxOptions();
  EditValueToggele: ToggleSlideOptions = new ToggleSlideOptions();
  EditDefaultValueToggele: ToggleSlideOptions = new ToggleSlideOptions();
  EditScope: DropdownOptions = new DropdownOptions();
  EditType: DropdownOptions = new DropdownOptions();
  EditPermissionSet: DropdownOptions = new DropdownOptions();
  EditUser: DropdownOptions = new DropdownOptions();
  EditSource: DropdownOptions = new DropdownOptions();
  EditLookup: DropdownOptions = new DropdownOptions();
  EditLookupValue: DropdownOptions = new DropdownOptions();
  EditLookupDefaultValue: DropdownOptions = new DropdownOptions();
  EditSourceFuncValue: DropdownOptions = new DropdownOptions();
  EditSourceFuncDefaultValue: DropdownOptions = new DropdownOptions();
  ConfigurationId: number;
  ConfigurationValueType: number;
  EditConfigurationTypeName: string;
  EditConfigurationScopeName: string;
  EditConfigurationDDLSourceName: string;
  @ViewChild('CloseEditConfigurationModal', { static: false }) CloseEditConfigurationModal: ElementRef;

  //delete  Model Controls
  deleteConfigurationList: any[] = []
  @ViewChild('CloseDeleteConfigurationModal', { static: false }) CloseDeleteConfigurationModal: ElementRef;
  language: string = ""

  ShowPageContent: boolean = false

  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private ConfigurationsService: ConfigurationsService, private modalService: NgbModal) {
  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;  
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Configuration")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }

  LoadDropdownLists() {
    this.ConfigurationsService.Loaddropdowns().subscribe((result) => {

      let DropdownLists = result as any
      //console.log("DropdownLists:",DropdownLists)
      this.ScopesList = DropdownLists.scopes
      this.PermissionList = DropdownLists.permissionList
      this.UsersList = DropdownLists.users
      this.LookupsList = DropdownLists.lookups
      this.ValueTypeList = DropdownLists.valueType
      this.ValueSourceList = DropdownLists.valueSource


      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
      this.searchTextBox.HideLabel = true

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.ConfigurationPaging = new PagingOptions();
      this.ConfigurationPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetConfigurationsByFilter';
      this.ConfigurationPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.ConfigurationPaging.Filters = [this.TextInputFilter]
      this.ConfigurationPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
    })
  }

  ReinitializeConfigurationPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateConfigurationPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setConfigurationListResult(result) {
    this.ConfigurationPagingResult = result
    this.ShowPageContent = true;
    this.utilityService.stopBlockUI();
  }

  resetFilters() {
    this.ConfigurationForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  ChangeScopeValue(key) {
    let scopItem = this.ScopesList.filter((item) => { return parseInt(item.key) == key; }).map((item) => item)[0];
    //console.log(scopItem);
    switch (scopItem.value) {
      case "App":
        this.ShowPermissionList = false;
        this.ShowUsersList = false;
        this.AddConfigurationForm.removeControl("User")
        this.AddConfigurationForm.removeControl("PermissionSet")

        break;
      case "Permission set":
        this.ShowPermissionList = true;
        this.ShowUsersList = false;
        this.AddConfigurationForm.removeControl("User")

        break;
      case "User":
        this.ShowPermissionList = false;
        this.ShowUsersList = true;
        this.AddConfigurationForm.removeControl("PermissionSet")

        break;
      default:
        break;
    }
  }
  ChangeTypeValue(key) {
    let typeItem = this.ValueTypeList.filter((item) => { return parseInt(item.key) == key; }).map((item) => item)[0];
    //console.log(typeItem);
    switch (typeItem.value) {
      case "Text":
        this.ShowValueAndDefaultValue = true;
        this.ShowValueToggleAndDefaultValue = false;
        this.ShowSourcePath = false;
        this.ShowDropDownSource = false;
        this.ShowLookupList = false;
        this.ShowLookupItemsList = false;
        this.AddConfigurationForm.removeControl("Source")
        break;
      case "Toggle":
        this.ShowValueAndDefaultValue = false;
        this.ShowValueToggleAndDefaultValue = true;
        this.ShowSourcePath = false;
        this.ShowDropDownSource = false;
        this.ShowLookupList = false;
        this.ShowLookupItemsList = false;
        this.AddConfigurationForm.removeControl("Source")

        break;
      case "Partial View":
        this.ShowValueAndDefaultValue = false;
        this.ShowValueToggleAndDefaultValue = false;
        this.ShowSourcePath = true;
        this.ShowDropDownSource = false;
        this.ShowLookupList = false;
        this.ShowLookupItemsList = false;
        this.AddConfigurationForm.removeControl("Source")

        break;
      case "Dropdown List":
        this.ShowLookupList = false;
        this.ShowValueAndDefaultValue = false;
        this.ShowValueToggleAndDefaultValue = false;
        this.ShowSourcePath = false;
        this.ShowDropDownSource = true;
        break;
      default:
        break;
    }
  }
  ChangeSource(key) {
    let sourceItem = this.ValueSourceList.filter((item) => { return parseInt(item.key) == key; }).map((item) => item)[0];
    //console.log(sourceItem);
    switch (sourceItem.value) {
      case "Lookup":
        this.ShowLookupList = true;
        this.ShowSourceFunctionPath = false;
        break;
      case "Function":
        this.ShowSourceFunctionPath = true;
        this.ShowLookupList = false;
        this.ShowLookupItemsList = false;
        break;
      default:
        break;
    }
  }
  ChangeLookup(key) {
    this.ConfigurationsService.LoadLookupItems(key).subscribe((result) => {
      let Result = result as any;
      this.LookupItemsList = Result.lookupItems;
      this.LookupValue = new DropdownOptions();
      this.LookupValue.Name = "LookupValue";
      this.LookupValue.LabelKey = "Value";
      this.LookupValue.SelectedItems = null;
      this.LookupValue.DataSource = this.LookupItemsList;
      this.LookupValue.SingleSelection = true;
      this.LookupValue.AllowSearchFilter = true;
      this.LookupValue.IsRequired = true;
      this.LookupValue.ShowAsterisk = true;

      this.LookupDefaultValue = new DropdownOptions();
      this.LookupDefaultValue.Name = "LookupDefaultValue";
      this.LookupDefaultValue.LabelKey = "DefaultValue";
      this.LookupDefaultValue.SelectedItems = null;
      this.LookupDefaultValue.DataSource = this.LookupItemsList;
      this.LookupDefaultValue.SingleSelection = true;
      this.LookupDefaultValue.AllowSearchFilter = true;
      this.LookupDefaultValue.IsRequired = true;
      this.ShowLookupItemsList = true;
    }, (error) => {
    });
  }
  ChangeEditLookup(key) {
    this.ShowLookupItemsList = false;

    this.ConfigurationsService.LoadLookupItems(key).subscribe((result) => {
      let Result = result as any;
      let LookupItemsListEdit = Result.lookupItems;
      //Resinitialize lookup values and default values

      this.EditLookupValue = new DropdownOptions();
      this.EditLookupValue.Name = "EditLookupValue";
      this.EditLookupValue.LabelKey = "Value";
      this.EditLookupValue.SelectedItems = null;
      this.EditLookupValue.DataSource = LookupItemsListEdit;
      this.EditLookupValue.SingleSelection = true;
      this.EditLookupValue.AllowSearchFilter = true;
      this.EditLookupValue.IsRequired = true;

      this.EditLookupDefaultValue = new DropdownOptions();
      this.EditLookupDefaultValue.Name = "EditLookupDefaultValue";
      this.EditLookupDefaultValue.LabelKey = "DefaultValue";
      this.EditLookupDefaultValue.SelectedItems = null;
      this.EditLookupDefaultValue.DataSource = LookupItemsListEdit;
      this.EditLookupDefaultValue.SingleSelection = true;
      this.EditLookupDefaultValue.AllowSearchFilter = true;
      this.EditLookupDefaultValue.IsRequired = true;

      this.ShowLookupItemsList = true;

    }, (error) => {
    });
  }
  showAddConfigurationModal(AddConfigurationModal) {
    this.AddConfigurationForm = new FormGroup({});
    this.ShowPermissionList = false;
    this.ShowUsersList = false;
    this.ShowValueAndDefaultValue = false;
    this.ShowValueToggleAndDefaultValue = false;
    this.ShowSourcePath = false;
    this.ShowDropDownSource = false;
    this.ShowLookupList = false;
    this.ShowLookupItemsList = false;
    this.ShowSourceFunctionPath = false;
    this.ShowLookupList = false;
    this.ShowLookupItemsList = false;
    this.utilityService.startBlockUI();

    this.Key = new TextBoxOptions();
    this.Key.Name = "Key";
    this.Key.LabelKey = "Key";
    this.Key.Type = InputType.Text;
    this.Key.IsRequired = true;
    this.Key.Value = null;

    this.Value = new TextBoxOptions();
    this.Value.Name = "Value";
    this.Value.LabelKey = "Value";
    this.Value.Type = InputType.Text;
    this.Value.Value = null;
    this.Value.IsRequired = true;


    this.DefaultValue = new TextBoxOptions();
    this.DefaultValue.Name = "DefaultValue";
    this.DefaultValue.LabelKey = "DefaultValue";
    this.DefaultValue.Type = InputType.Text;
    this.DefaultValue.Value = null;
    this.DefaultValue.IsRequired = true;

    this.SourcePath = new TextBoxOptions();
    this.SourcePath.Name = "SourcePath";
    this.SourcePath.LabelValue = "SourcePath";
    this.SourcePath.LabelKey = "SourcePath";
    this.SourcePath.Type = InputType.Text;
    this.SourcePath.Value = null;


    this.FunctionSourcePath = new TextBoxOptions();
    this.FunctionSourcePath.Name = "FunctionSourcePath";
    this.FunctionSourcePath.LabelValue = "SourcePath";
    this.FunctionSourcePath.LabelKey = "SourcePath";
    this.FunctionSourcePath.Type = InputType.Text;
    this.FunctionSourcePath.Value = null;


    this.ValueToggel = new ToggleSlideOptions();
    this.ValueToggel.Name = "ValueToggel";
    this.ValueToggel.LabelKey = "Value";
    this.ValueToggel.Value = false;
    this.ValueToggel.ViewType = ControlLayout.Horizontal;

    this.DefaultValueToggel = new ToggleSlideOptions();
    this.DefaultValueToggel.Name = "DefaultValueToggel";
    this.DefaultValueToggel.LabelKey = "DefaultValue";
    this.DefaultValueToggel.Value = false;
    this.DefaultValueToggel.ViewType = ControlLayout.Horizontal;

    this.Scope = new DropdownOptions();
    this.Scope.Name = "Scope";
    this.Scope.LabelKey = "Scope";
    this.Scope.SelectedItems = null;
    this.Scope.DataSource = this.ScopesList;
    this.Scope.SingleSelection = true;
    this.Scope.AllowSearchFilter = true;
    this.Scope.IsRequired = true;

    this.Type = new DropdownOptions();
    this.Type.Name = "Type";
    this.Type.LabelKey = "Type";
    this.Type.SelectedItems = null;
    this.Type.DataSource = this.ValueTypeList;
    this.Type.SingleSelection = true;
    this.Type.AllowSearchFilter = true;
    this.Type.IsRequired = true;

    this.PermissionSet = new DropdownOptions();
    this.PermissionSet.Name = "PermissionSet";
    this.PermissionSet.LabelKey = "PermissionSet";
    this.PermissionSet.SelectedItems = null;
    this.PermissionSet.DataSource = this.PermissionList;
    this.PermissionSet.SingleSelection = true;
    this.PermissionSet.AllowSearchFilter = true;
    this.PermissionSet.IsRequired = true;

    this.User = new DropdownOptions();
    this.User.Name = "User";
    this.User.LabelKey = "User";
    this.User.SelectedItems = null;
    this.User.DataSource = this.UsersList;
    this.User.SingleSelection = true;
    this.User.AllowSearchFilter = true;
    this.User.IsRequired = true;

    this.Source = new DropdownOptions();
    this.Source.Name = "Source";
    this.Source.LabelKey = "Source";
    this.Source.SelectedItems = null;
    this.Source.DataSource = this.ValueSourceList;
    this.Source.SingleSelection = true;
    this.Source.AllowSearchFilter = true;
    this.Source.IsRequired = true;

    this.Lookup = new DropdownOptions();
    this.Lookup.Name = "Lookup";
    this.Lookup.LabelKey = "Lookup";
    this.Lookup.SelectedItems = null;
    this.Lookup.DataSource = this.LookupsList;
    this.Lookup.SingleSelection = true;
    this.Lookup.AllowSearchFilter = true;
    this.Lookup.IsRequired = true;

    this.modalService.open(AddConfigurationModal);
    this.utilityService.stopBlockUI();
  }

  addConfiguration() {
    if (this.AddConfigurationForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddConfigurationForm.value;
      let AddModel: ConfigurationModel = new ConfigurationModel();
      AddModel.Key = ResultModel.Key;
      AddModel.ScopeId = Number(ResultModel.Scope);
      AddModel.ValueType = Number(ResultModel.Type);
      AddModel.TextValue = ResultModel.Value;
      AddModel.DefaultTextValue = ResultModel.DefaultValue;
      AddModel.BoolValue = ResultModel.ValueToggel;
      AddModel.DefaultBoolValue = ResultModel.DefaultValueToggel;
      AddModel.SourcePartialViewActionName = ResultModel.SourcePath;
      AddModel.SourceFunctionName = ResultModel.FunctionSourcePath;
      AddModel.UserID = Number(ResultModel.User);
      AddModel.SelectedLookupID = Number(ResultModel.Lookup);
      AddModel.Value = ResultModel.LookupValue;
      AddModel.DefaultValue = ResultModel.LookupDefaultValue;

      AddModel.PermissionSetID = Number(ResultModel.PermissionSet);
      AddModel.ValueSource = Number(ResultModel.Source);

      let sourceItem = this.ValueSourceList.filter((item) => { return parseInt(item.key) == AddModel.ValueSource; }).map((item) => item)[0];
      if (sourceItem != undefined) {
        let ConfigurationDDLSourceName = sourceItem.value;
        if (ConfigurationDDLSourceName == "Function") {
          AddModel.Value = ResultModel.SourceFuncValue;
          AddModel.DefaultValue = ResultModel.SourceFuncDefaultValue;
        }
      }
      this.ConfigurationsService.AddConfiguration(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      })
    }
  }


  showEditConfigurationModal(configurationId: number, configurationIDEnc: string, EditConfigurationModal) {
    this.EditConfigurationForm = new FormGroup({})
    this.resetConfigurationFlags();
    this.ConfigurationsService.GetEditConfiguration(configurationIDEnc).subscribe((result: any) => {
      let configuration = result.model as any;
      this.ConfigurationId = configurationId;
      this.ConfigurationValueType = configuration.valueType;
      this.EditKey = new TextBoxOptions();
      this.EditKey.Name = "EditKey";
      this.EditKey.LabelKey = "Key";
      this.EditKey.Type = InputType.Text;
      this.EditKey.IsRequired = true;
      this.EditKey.Value = configuration.key;
      this.EditKey.MaxLength = 256;
      this.EditKey.IsDisabled = this.ProductionMode == true;

      let typeItem = this.ValueTypeList.filter((item) => { return parseInt(item.key) == configuration.valueType; }).map((item) => item)[0];
      this.EditConfigurationTypeName = typeItem.value;
      switch (this.EditConfigurationTypeName) {
        case "Text":
          this.ShowValueAndDefaultValue = true;
          this.EditTextValue = new TextBoxOptions();
          this.EditTextValue.Name = "EditTextValue";
          this.EditTextValue.LabelKey = "Value";
          this.EditTextValue.Type = InputType.Text;
          this.EditTextValue.Value = configuration.textValue;
          this.EditTextValue.IsRequired = true;


          this.EditTextDefaultValue = new TextBoxOptions();
          this.EditTextDefaultValue.Name = "EditTextDefaultValue";
          this.EditTextDefaultValue.LabelKey = "DefaultValue";
          this.EditTextDefaultValue.Type = InputType.Text;
          this.EditTextDefaultValue.Value = configuration.defaultTextValue;
          this.EditTextDefaultValue.IsRequired = true;
          break;
        case "Toggle":
          this.ShowValueToggleAndDefaultValue = true;
          this.EditValueToggele = new ToggleSlideOptions();
          this.EditValueToggele.Name = "EditValueToggele";
          this.EditValueToggele.LabelKey = "Value";
          this.EditValueToggele.Value = configuration.boolValue;
          this.EditValueToggele.ViewType = ControlLayout.Horizontal;

          this.EditDefaultValueToggele = new ToggleSlideOptions();
          this.EditDefaultValueToggele.Name = "EditDefaultValueToggele";
          this.EditDefaultValueToggele.LabelKey = "DefaultValue";
          this.EditDefaultValueToggele.Value = configuration.defaultBoolValue;
          this.EditDefaultValueToggele.ViewType = ControlLayout.Horizontal;
          break;
        case "Dropdown List":
          let sourceItem = this.ValueSourceList.filter((item) => { return parseInt(item.key) == configuration.valueSource; }).map((item) => item)[0];
          this.EditConfigurationDDLSourceName = sourceItem.value;
          switch (this.EditConfigurationDDLSourceName) {
            case "Lookup":
              this.ShowLookupList = true;
              this.ShowLookupItemsList = true;
              let selectedLookup = this.LookupsList.filter((item) => { return item.key == configuration.selectedLookupID; }).map((item) => item.key)[0];

              this.EditLookup = new DropdownOptions();
              this.EditLookup.Name = "EditLookup";
              this.EditLookup.LabelKey = "Lookup";
              this.EditLookup.SelectedItems = null;
              this.EditLookup.DataSource = this.LookupsList;
              this.EditLookup.SingleSelection = true;
              this.EditLookup.AllowSearchFilter = true;
              this.EditLookup.IsRequired = true;
              this.EditLookup.SelectedItems = selectedLookup;

              let selectedLookupValue = result.lookupItemsSource.filter((item) => { return item.key == configuration.value; }).map((item) => item.key)[0];
              this.EditLookupValue = new DropdownOptions();
              this.EditLookupValue.Name = "EditLookupValue";
              this.EditLookupValue.LabelKey = "Value";
              this.EditLookupValue.DataSource = result.lookupItemsSource;
              this.EditLookupValue.SingleSelection = true;
              this.EditLookupValue.AllowSearchFilter = true;
              this.EditLookupValue.IsRequired = true;
              this.EditLookupValue.SelectedItems = selectedLookupValue;

              let selectedLookupDefaultValue = result.lookupItemsSource.filter((item) => { return item.key == configuration.defaultValue; }).map((item) => item.key)[0];
              this.EditLookupDefaultValue = new DropdownOptions();
              this.EditLookupDefaultValue.Name = "EditLookupDefaultValue";
              this.EditLookupDefaultValue.LabelKey = "DefaultValue";
              this.EditLookupDefaultValue.DataSource = result.lookupItemsSource;
              this.EditLookupDefaultValue.SingleSelection = true;
              this.EditLookupDefaultValue.AllowSearchFilter = true;
              this.EditLookupDefaultValue.IsRequired = true;
              this.EditLookupDefaultValue.SelectedItems = selectedLookupDefaultValue;
              break;
            case "Function":
              this.EditFunctionSourcePath = new TextBoxOptions();
              this.EditFunctionSourcePath.Name = "EditFunctionSourcePath";
              this.EditFunctionSourcePath.LabelKey = "SourcePath";
              this.EditFunctionSourcePath.Type = InputType.Text;
              this.EditFunctionSourcePath.Value = configuration.sourceFunctionName;
              this.EditFunctionSourcePath.IsRequired = true;


              this.ConfigurationsService.LoadSourceFunctionDropDownItems(configuration.sourceFunctionName).subscribe((result: any) => {
                let selectedSourceFuncValue = result.filter((item) => { return item.key == configuration.value; }).map((item) => item.key)[0];
                this.EditSourceFuncValue = new DropdownOptions();
                this.EditSourceFuncValue.Name = "EditSourceFuncValue";
                this.EditSourceFuncValue.LabelKey = "Value";
                this.EditSourceFuncValue.DataSource = result;
                this.EditSourceFuncValue.SingleSelection = true;
                this.EditSourceFuncValue.AllowSearchFilter = true;
                this.EditSourceFuncValue.IsRequired = true;
                this.EditSourceFuncValue.SelectedItems = selectedSourceFuncValue;

                let selectedSourceFuncDefaultValue = result.filter((item) => { return item.key == configuration.defaultValue; }).map((item) => item.key)[0];
                this.EditSourceFuncDefaultValue = new DropdownOptions();
                this.EditSourceFuncDefaultValue.Name = "EditSourceFuncDefaultValue";
                this.EditSourceFuncDefaultValue.LabelKey = "DefaultValue";
                this.EditSourceFuncDefaultValue.DataSource = result;
                this.EditSourceFuncDefaultValue.SingleSelection = true;
                this.EditSourceFuncDefaultValue.AllowSearchFilter = true;
                this.EditSourceFuncDefaultValue.IsRequired = true;
                this.EditSourceFuncDefaultValue.SelectedItems = selectedSourceFuncDefaultValue;
                this.ShowSourceFunctionPath = true;

              }, (error) => {
                
              })
              break;
            default:
              break;
          }

          break;
        default:
          break;
      }

      let scopItem = this.ScopesList.filter((item) => { return parseInt(item.key) == configuration.scopeId; }).map((item) => item)[0];
      this.EditConfigurationScopeName = scopItem.value;

      //console.log(scopItem);
      switch (this.EditConfigurationScopeName) {
        case "Permission set":
          this.ShowPermissionList = true;
          let selectedPermissionSet = this.PermissionList.filter((item) => { return item.key == configuration.permissionSetID; }).map((item) => item.key)[0];
          this.EditPermissionSet = new DropdownOptions();
          this.EditPermissionSet.Name = "EditPermissionSet";
          this.EditPermissionSet.LabelKey = "PermissionSet";
          this.EditPermissionSet.SelectedItems = null;
          this.EditPermissionSet.DataSource = this.PermissionList;
          this.EditPermissionSet.SingleSelection = true;
          this.EditPermissionSet.AllowSearchFilter = true;
          this.EditPermissionSet.IsRequired = true;
          this.EditPermissionSet.SelectedItems = selectedPermissionSet;
          break;
        case "User":
          this.ShowUsersList = true;
          let selectedUser = this.UsersList.filter((item) => { return item.key == configuration.userID; }).map((item) => item.key)[0];
          this.EditUser = new DropdownOptions();
          this.EditUser.Name = "EditUser";
          this.EditUser.LabelKey = "User";
          this.EditUser.SelectedItems = null;
          this.EditUser.DataSource = this.UsersList;
          this.EditUser.SingleSelection = true;
          this.EditUser.AllowSearchFilter = true;
          this.EditUser.IsRequired = true;
          this.EditUser.SelectedItems = selectedUser;
          break;
        default:
          break;
      }
      this.modalService.open(EditConfigurationModal);
    }, (error) => {
   
    })
  }
  resetConfigurationFlags() {
    this.ShowPermissionList = false;
    this.ShowUsersList = false;
    this.ShowLookupList = false;

    this.ShowValueAndDefaultValue = false;
    this.ShowValueToggleAndDefaultValue = false;
    this.ShowSourcePath = false;
    this.ShowSourceFunctionPath = false;
    this.ShowDropDownSource = false;
    this.ShowLookupItemsList = false;
    this.ShowSourceFunctionData = false;
  }
  SearchForFunction(isAdd: boolean = true) {
    let ResultModel = isAdd ? this.AddConfigurationForm.value : this.EditConfigurationForm.value;
    let functionName = isAdd ? ResultModel.FunctionSourcePath: ResultModel.EditFunctionSourcePath;
    this.ConfigurationsService.LoadSourceFunctionDropDownItems(functionName).subscribe((result: any) => {
      if (isAdd) {
        this.SourceFuncValue = new DropdownOptions();
        this.SourceFuncValue.Name = "SourceFuncValue";
        this.SourceFuncValue.LabelKey = "Value";
        this.SourceFuncValue.DataSource = result;
        this.SourceFuncValue.SingleSelection = true;
        this.SourceFuncValue.AllowSearchFilter = true;
        this.SourceFuncValue.IsRequired = true;

        this.SourceFuncDefaultValue = new DropdownOptions();
        this.SourceFuncDefaultValue.Name = "SourceFuncDefaultValue";
        this.SourceFuncDefaultValue.LabelKey = "DefaultValue";
        this.SourceFuncDefaultValue.DataSource = result;
        this.SourceFuncDefaultValue.SingleSelection = true;
        this.SourceFuncDefaultValue.AllowSearchFilter = true;
        this.SourceFuncDefaultValue.IsRequired = true;
        this.ShowSourceFunctionData = true;
      }
      else {
        this.EditSourceFuncValue = new DropdownOptions();
        this.EditSourceFuncValue.Name = "EditSourceFuncValue";
        this.EditSourceFuncValue.LabelKey = "Value";
        this.EditSourceFuncValue.DataSource = result;
        this.EditSourceFuncValue.SingleSelection = true;
        this.EditSourceFuncValue.AllowSearchFilter = true;
        this.EditSourceFuncValue.IsRequired = true;

        this.EditSourceFuncDefaultValue = new DropdownOptions();
        this.EditSourceFuncDefaultValue.Name = "EditSourceFuncDefaultValue";
        this.EditSourceFuncDefaultValue.LabelKey = "DefaultValue";
        this.EditSourceFuncDefaultValue.DataSource = result;
        this.EditSourceFuncDefaultValue.SingleSelection = true;
        this.EditSourceFuncDefaultValue.AllowSearchFilter = true;
        this.EditSourceFuncDefaultValue.IsRequired = true;
      }

    }, (error) => {
    
    })
  }
  editConfiguration() {
    if (this.EditConfigurationForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditConfigurationForm.value;
      console.log(ResultModel);
      let EditModel: ConfigurationModel = new ConfigurationModel();
      EditModel.ID = this.ConfigurationId;
      EditModel.ValueType = this.ConfigurationValueType;
      if (this.ProductionMode == false)
        EditModel.Key = ResultModel.EditKey;
      console.log(this.EditConfigurationTypeName);
      switch (this.EditConfigurationTypeName) {
        case "Text":
          EditModel.TextValue = ResultModel.EditTextValue;
          EditModel.DefaultTextValue = ResultModel.EditTextDefaultValue;
          break;
        case "Toggle":
          EditModel.BoolValue = ResultModel.EditValueToggele;
          EditModel.DefaultBoolValue = ResultModel.EditDefaultValueToggele;
          break;
        case "Dropdown List":
          if (this.EditConfigurationDDLSourceName == "Lookup") {
            EditModel.SelectedLookupID = Number(ResultModel.EditLookup);
            EditModel.Value = ResultModel.EditLookupValue as string;
            EditModel.DefaultValue = ResultModel.EditLookupDefaultValue as string;
          }
          else if (this.EditConfigurationDDLSourceName == "Function")
          {
            EditModel.SourceFunctionName = ResultModel.EditFunctionSourcePath;
            EditModel.Value = ResultModel.EditSourceFuncValue;
            EditModel.DefaultValue = ResultModel.EditSourceFuncDefaultValue;
          }
          break;
      }
      if (this.EditConfigurationScopeName == "User") {
        console.log(Number(ResultModel.EditUser));
        EditModel.UserID = Number(ResultModel.EditUser);
      }
      else if (this.EditConfigurationScopeName == "Permission set")
        EditModel.PermissionSetID = Number(ResultModel.EditPermissionSet);

      //EditModel.SourcePartialViewActionName = ResultModel.SourcePath;


      this.ConfigurationsService.EditConfiguration(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        this.resetConfigurationFlags();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      })
    }
  }

  showDeleteConfigurationModal(Configuration: any, deleteConfigurationModal) {
    this.utilityService.startBlockUI()
    this.deleteConfigurationList = []
    this.deleteConfigurationList.push(Configuration);
    this.modalService.open(deleteConfigurationModal);
    this.utilityService.stopBlockUI();
  }

  deleteConfiguration() {
    let UsersIDModel: UsersIDRequestModel = new UsersIDRequestModel();
    for (let index = 0; index < this.deleteConfigurationList.length; index++) {
      const element = this.deleteConfigurationList[index];
      UsersIDModel.UsersIDs.push(element.id)

    }
    this.ConfigurationsService.DeleteConfiguration( UsersIDModel).subscribe((result) => {
      this.deleteConfigurationList = [];
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    
    })

  }


}
